<script setup>
import {useI18n} from "vue-i18n";

const { locale } = useI18n()

const steps = [
  {
    id: 1,
    title: 'Выберите услугу',
    text: 'Оставьте заявку\nна подключение',
    icon: '/img/connect/search.svg',
    buttonText: 'Выбрать услугу',
    href: `${import.meta.env.VITE_HOST}/${locale.value}/katalog-uslug`
  },
  {
    id: 2,
    title: 'Проверим адрес',
    text: 'Подтвердим\nдоступность по адресу',
    icon: '/img/connect/location.svg',
    buttonText: '',
    href: ''
  },
  {
    id: 3,
    title: 'Подключим услугу',
    text: 'Выполним установку\nи настройку',
    icon: '/img/connect/wifi.svg',
    buttonText: '',
    href: ''
  }
]

const handleButtonClick = (step) => {
  if (!step.href) return
  window.location.href = step.href
}
</script>

<template>
  <section class="connect-steps">
    <h2 class="connect-steps__title">
      {{$t('Как подключить услугу')}}
    </h2>

    <div class="connect-steps__list">
      <template v-for="(step, index) in steps" :key="step.id">
        <div
            class="connect-step"
            :class="{ 'has-button': step.buttonText }"
        >
          <div class="connect-step__icon">
            <img :src="step.icon" :alt="step.title">
          </div>

          <h3 class="connect-step__title">
            {{ $t(step.title) }}
          </h3>

          <div class="connect-step__content">
            <p class="connect-step__text">
              {{ $t(step.text) }}
            </p>

            <button
                v-if="step.buttonText"
                class="connect-step__button"
                type="button"
                @click="handleButtonClick(step)"
            >
              {{ $t(step.buttonText) }}
            </button>
          </div>
        </div>

        <div
            v-if="index !== steps.length - 1"
            class="connect-steps__arrow"
        >
          <img src="/img/connect/arrow-b.svg" alt="arrow">
        </div>
      </template>
    </div>
  </section>
</template>

<style scoped>
.connect-steps {
  width: 100%;
  background: #ffffff;
  border-radius: 0 0 40px 40px;
  padding: 80px 0;
  box-sizing: border-box;
}

.connect-steps__title {
  margin: 0 0 32px;
  font-size: 36px;
  line-height: 100%;
  font-weight: 600;
  color: $primary-dark;
  text-align: center;
}

.connect-steps__list {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
}

.connect-step {
  width: 230px;
  min-height: 204px;
  border-radius: 16px;
  background: transparent;
  padding: 16px 24px;
  box-sizing: border-box;
  text-align: center;

  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  &:hover {
    .connect-step__icon {
      transform: scale(1.1);
    }
  }
}

.connect-step:hover {
  background: #f7fbff;
}

.connect-step__content {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.connect-step__icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
}

.connect-step__icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.connect-step__title {
  margin: 0 0 8px;
  font-size: 18px;
  line-height: 100%;
  font-weight: 600;
  color: $primary-dark;
}

.connect-step__text {
  margin: 0;
  font-size: 16px;
  line-height: normal;
  color: #495057;
  white-space: pre-line;

  transition: opacity 0.2s ease, transform 0.2s ease;
}

.connect-step__button {
  position: absolute;

  width: 164px;
  height: 32px;
  border: none;
  border-radius: 6px;
  background: #1388ee;
  color: #fff;
  font-size: 14px;
  cursor: pointer;

  opacity: 0;
  transform: translateY(6px);
  transition: all 0.2s ease;
}

.connect-step.has-button:hover .connect-step__text {
  opacity: 0;
  transform: translateY(-6px);
}

.connect-step.has-button:hover .connect-step__button {
  opacity: 1;
  transform: translateY(0);
}

.connect-step:hover .connect-step__button {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.connect-step__button:hover {
  background: #087ce0;
}

.connect-steps__arrow {
  margin-top: -10px;
  font-size: 32px;
  line-height: 1;
  color: #1388ee;
  flex-shrink: 0;
}

@media (max-width: 900px) {
  .connect-steps {
    display: none;
  }

}
</style>
